import { render, staticRenderFns } from "./omsetkota_chart.vue?vue&type=template&id=04489e76"
import script from "./omsetkota_chart.vue?vue&type=script&lang=js"
export * from "./omsetkota_chart.vue?vue&type=script&lang=js"
import style0 from "./omsetkota_chart.vue?vue&type=style&index=0&id=04489e76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports